export default __webpack_public_path__ + "images/Schuetten-Displays-in-Container.webp?a2a0335a45b6cf04d95e8d105705c1a0";